import * as React from 'react';
import config from 'app/config';
import { useMutation } from 'react-query';
/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const style = css`
    position: absolute;
    top: 20%;
    bottom: 0;
    left: 0;
    right: 0;
	
    .message {
		text-align: center;
    }
	
	.text-muted {
		color: #c8c8c8;
		padding-top: 30px;
	}
`;

const BoundaryHook = props => {

	return (
		<div css={style}>
			<div className="message">
				<h1>Something went wrong.</h1>
				<a href="/">Go To Dashboard</a>
				{props.errorId && <div className="text-muted">Error #{props.errorId}</div>}
			</div>
		</div>
	);
}



export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null, info: null, errorId: null };
	}

	componentDidCatch(error, info) {

		if (!document.location.host.startsWith('localhost')) {
			fetch(`${config.baseURI}/nv/system-error`, {
				method: 'POST',
				body: JSON.stringify({
					httpMethod: 'FRONTEND',
					uri: this.props.pathname ?? this.props.location?.pathname,
					ipAddress: '',
					request: '',
					response: error.toString(),
					stackTrace: info.componentStack,
					queryString: this.props.search ?? this.props.location?.search
				}),
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + this.props.auth?.token
				}
			}).then(res => {
				res.json().then(data => {
					if (data.id) {
						this.setState({
							hasError: true,
							error: error.toString(),
							info: info,
							errorId: data.id
						})
					}
				});
			})
		}
	
		this.setState({ hasError: true, error: error.toString(), info: info });
	}

	render() {

		if (this.props.auth?.token && this.state.hasError) {
			return <BoundaryHook
				errorId={this.state.errorId}
				error={this.state.error}
				uri={this.props.location?.pathname}
				info={this.state.info}
				queryString={this.props.location?.search}
				authToken={this.props.auth?.token}
			/>
		}

		return this.props.children;
	}
}